/* card-hover-image.js
   Laadt de tweede foto van een productkaart (de hover-foto) alleen op desktop.
   Reden: die foto stond altijd in de HTML met opacity 0, dus een telefoon haalde hem
   op terwijl hover daar niet bestaat. Zie snippets/card-product.liquid.
   Toegevoegd 24-9-2026. */
(function () {
  var MQ = '(min-width: 990px)';
  var SEL = 'img.card-hover-img[data-src]';

  function vul(img) {
    if (img.dataset.srcset) {
      img.setAttribute('srcset', img.dataset.srcset.trim());
      delete img.dataset.srcset;
    }
    if (img.dataset.alt) {
      img.setAttribute('alt', img.dataset.alt);
      delete img.dataset.alt;
    }
    img.setAttribute('src', img.dataset.src);
    delete img.dataset.src;
  }

  function vulAlles(root) {
    (root || document).querySelectorAll(SEL).forEach(vul);
  }

  function desktop() {
    return window.matchMedia && window.matchMedia(MQ).matches;
  }

  function start() {
    if (!desktop()) return;
    vulAlles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Kaarten die later binnenkomen: collectiefilters, quick add, section rendering.
  if (window.MutationObserver) {
    var wacht = null;
    new MutationObserver(function () {
      if (!desktop() || wacht) return;
      wacht = setTimeout(function () {
        wacht = null;
        vulAlles();
      }, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Draaien van telefoon naar tablet-breedte of venster groter slepen.
  if (window.matchMedia) {
    var mq = window.matchMedia(MQ);
    var bij = function () { if (mq.matches) vulAlles(); };
    if (mq.addEventListener) mq.addEventListener('change', bij);
    else if (mq.addListener) mq.addListener(bij);
  }
})();
